export function getTipsClassPosition(titlePosition: number) {
    return {
        marginTop: `${titlePosition}px`,
    };
}
